<template>
    <div
        class="is-flex is-multiline is-variable is-1 is-justify-content-center is-align-items-center is-flex-direction-column">
        <div class="is-flex is-align-items-center" v-if="mensajeCorto == false">
            <div>
                <img class="mr-5" style="width:76px" :src="siiLogo" />
            </div>
            <div class="pr-5">
                <p>
                    <span class="has-text-weight-semibold">
                        Automatiza tus documentos
                    </span>
                    del Servicio de Impuestos Internos a través de
                    <FintocLogo class="is-relative" style="width:60px;vertical-align:bottom; top:1px" />
                </p>
                <p v-if="isWaiting">
                    Deseas conocer más en detalle esté proceso
                    <a class="has-text-secondary is-underlined" type="is-text" v-on:click.prevent="toggleCollapse">
                        <span>Infórmate más aquí</span>
                        <i class="material-icons is-size-6 is-relative" style="top:3px">
                            {{
                                collapseIsOpen
                                    ? "keyboard_arrow_up"
                                    : "keyboard_arrow_down"
                            }}
                        </i>
                    </a>
                </p>
            </div>
            <div class="ml-auto">
                <img v-if="isWaiting" style="width:40px" class="has-text-secondary" :src="clock" />
            </div>
        </div>
        <div v-if="!isWaiting" class="has-text-centered mb-5">
            <b-button :loading="widgetIsLoading" type="is-secondary" @click="onConnectSii" :disabled="hasConnectSII"
                :icon-right="hasConnectSII ? 'check' : ''">
                <div class="is-flex is-justify-content-space-between is-align-item-center">
                    <span>¡Conéctate!</span>
                </div>
            </b-button>
        </div>
    </div>
</template>

<script>
import clock from "@/assets/images/clock.svg";
import siiLogo from "@/assets/images/sii.svg";
import FintocLogo from "@/components/svg/FintocLogo.vue";
export default {
    name: "SiiConnect",
    components: {
        FintocLogo,
    },
    props: {
        widgetIsLoading: {
            type: Boolean,
            default: false,
        },
        isWaiting: {
            type: Boolean,
            default: false,
        },
        hasConnectSII: {
            type: Boolean,
            default: false,
        },
        mensajeCorto: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            siiLogo: siiLogo,
            clock: clock,
        };
    },
    methods: {
        onConnectSii() {
            this.$emit("onConnectSii");
        },
    },
};
</script>
